import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=5f8efadf&scoped=true&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=5f8efadf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8efadf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f8efadf')) {
      api.createRecord('5f8efadf', component.options)
    } else {
      api.reload('5f8efadf', component.options)
    }
    module.hot.accept("./sidebar.vue?vue&type=template&id=5f8efadf&scoped=true&", function () {
      api.rerender('5f8efadf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/sidebar.vue"
export default component.exports